module.exports = __webpack_public_path__ + "img/type-sms.04c77f82.svg";